"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@ori-ui/mui-bundle/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M7.57 9.158a.5.5 0 0 0-.57.495v4.98a.5.5 0 0 0 .43.495l1.5.214a.5.5 0 0 0 .57-.495v-4.98a.5.5 0 0 0-.43-.495z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.974 19.601a5 5 0 0 1-.281.15c-.42.206-.875.227-1.276.165l-5.145-.791A1.5 1.5 0 0 1 4 17.642V5.666a1.5 1.5 0 0 1 1.728-1.483l5.348.823.026.005c.222.046.436.1.646.2q.13.062.248.142.13-.093.27-.16c.218-.107.433-.156.661-.188l5.345-.822A1.5 1.5 0 0 1 20 5.666v11.976a1.5 1.5 0 0 1-1.272 1.483l-5.208.8c-.347.054-.751.052-1.137-.11a2.5 2.5 0 0 1-.409-.214M6 9.653v4.98a1.5 1.5 0 0 0 1.288 1.484l1.5.215a1.5 1.5 0 0 0 1.712-1.485v-4.98a1.5 1.5 0 0 0-1.288-1.485l-1.5-.214A1.5 1.5 0 0 0 6 9.653m11.995-.724a.5.5 0 0 0-.566-.424l-3.5.5a.5.5 0 1 0 .142.99l3.5-.5a.5.5 0 0 0 .424-.566m0 3a.5.5 0 0 0-.566-.424l-3.5.5a.5.5 0 0 0 .142.99l3.5-.5a.5.5 0 0 0 .424-.566m-.424 3.566a.5.5 0 0 0-.142-.99l-3.5.5a.5.5 0 0 0 .142.99z"
  })]
}), 'CatalogueFilled');
